import React, { Component } from 'react';

import {QRCodeSVG} from 'qrcode.react';

export default class PrintLabels extends Component {
  render() {
    let id = this.props.box.id;
    let break_after = {
        display: 'block',
        pageBreakAfter: 'always',
        position: 'relative',
        marginTop: '2mm'
    };
    let fontSize = {fontSize: '13px'};
    let midFontSize = {fontSize: '16px'};
    let bigFontSize = {fontSize: '19px'};
    return (
      <div className="toPrint text-center" id={"toPrint" + this.props.index}>
        <div id={"myCanvas" + this.props.index}>
          <QRCodeSVG value={id.toString()} />
        </div>
        <div style={fontSize}>
          <div style={bigFontSize}>
            <b>ID:</b> {id}
          </div>
          <div>
            <b>Lot id: </b>
            {this.props.box.production_session ? this.props.box.production_session : this.props.box.lot ? this.props.box.lot : "-"}
          </div>
          <div>
            <b>Exp: </b> {this.props.box.expiration_date ? this.props.box.expiration_date : "-"}
          </div>
          <div>
            <b>Vendor: </b>
            {this.props.invoice.vendor.name ? this.props.invoice.vendor.name : "-"}
          </div>
          <div>
            <b>Brand: </b>
            {this.props.box.brand ? this.props.box.brand : "-"}
          </div>
          <div>
            <b>Packing-date: </b> {this.props.box.packingDate ? this.props.box.packingDate : "-"}
          </div>
          <div style={midFontSize}>
            <b style={fontSize}>Item: </b>
            {this.props.box.item}
          </div>
          <div>
            <b>Grade: </b>
            {this.props.box.grade ? this.props.box.grade : "N/A"}
          </div>
          <div>
            <b>Contains: </b>
            {this.props.box.allergies ? this.props.box.allergies : "-"}
          </div>
          <div>
            <b>Ingredients: </b>
            {this.props.box.ingredients ? this.props.box.ingredients : "-"}
          </div>
          <div>
            <b>Weight:</b> {this.props.box.weight ? this.props.box.weight : "-"}
          </div>
          <div>
            <b>Count: </b> {this.props.box.pieces ? this.props.box.pieces : "-"}
          </div>
        </div>
        <div style={break_after}></div>
      </div>
    );
  }
}
